'use client';

import {useCourseLandingComponentsApi} from '@/lib/hooks/use-course-landing-components-api';
import {useUserHasOrganization} from '@/lib/hooks/use-user-has-organization';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {OrgBuyButtonResponse} from '@/features/course-landing-page/types/org-buy-button-response';

interface BuyButtonApiResponse {
    buy_button: {
        button: OrgBuyButtonResponse;
    };
}

export function useClcBuyButtonContext(): OrgBuyButtonResponse | undefined {
    const course = useClpCourse();
    const userHasOrganization = useUserHasOrganization();

    const query = useCourseLandingComponentsApi<BuyButtonApiResponse>(course.id, 'buy_button', {
        enabled: userHasOrganization,
    });

    if (!userHasOrganization) {
        return undefined;
    }

    return query.data?.buy_button?.button;
}
